import React from 'react';
import store from '../store';
import actions from '../actions/episodeActions';

class PageNotFound extends React.Component {

  componentWillMount(){
    store.dispatch(actions.EPISODE_UPDATE_CURRENT(null));
  }

  render(){
    return (
      <div className="page-not-found">
        <h1>404 Page non trouvable</h1>
      </div>
    )
  }
}

export default PageNotFound;



// WEBPACK FOOTER //
// ./src/components/PageNotFound.js